import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import { IGateOutPost } from "src/common/typings/vehicle";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

export const vehicleRegistrationNumbersAction = createAsyncThunk(
  "gate-entry/vehicleRegNumbers", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-vehicle-registration-numbers?InProgressDataOnly=true");
      if (res.data.isSuccess === true && res.data.value) {
        return res.data.value.vehicleRegistrationNumbers;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const postVehicleRegistrationNumbersAction = createAsyncThunk(
  "gate-entry/postVehicleRegNumbers", // action string
  async (gatePassId: any) => {
    try {
      const res = await ax.get<IApi>(
        `/get-gate-pass-checkout-details-by-registration-number/${gatePassId}`
      );
      if (res.data.isSuccess === true && res.data.value) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const postGateOutAction = createAsyncThunk(
  "gate-entry/postGateOutAction",
  async (formRecord: IGateOutPost) => {
    try {
      const res = await ax.post<IApi>("/get-in-check-out-vehicle", formRecord);
      if (res.data.isSuccess === true) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const uploadWebCamImageAction = createAsyncThunk(
  "gate-entry/uploadWebCamImage",
  async (formRecord: any) => {
    try {
      const res = await ax.post<IApi>("/upload-gate-entry-image", formRecord);
      if (res.data.isSuccess === true) {
        return res.data.value;
      } else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
